import { Link } from '@tanstack/react-router';
import { Layout, List, Space, Typography } from 'antd';

import { ROUTE_CONSTANTS } from '@/routes';

const { Title } = Typography;

export function Home() {
  return (
    <Layout>
      <Layout.Content style={{ overflow: 'auto' }}>
        <Title level={2} style={{ marginBottom: '24px' }}>
          Herzlich willkommen, Partner der mail alliance.
        </Title>
        <Typography.Text>
          Während Sie eingeloggt sind, können Sie das volle Angebot nutzen:
        </Typography.Text>

        <List style={{ marginTop: '8px' }}>
          <List.Item>
            <Space align='baseline'>
              <Typography.Text style={{ color: 'red', fontWeight: 'bold' }}>✓</Typography.Text>
              <Typography.Text>
                alle nötige{' '}
                <Link to='/apps'>
                  <Typography.Text strong style={{ color: 'red' }}>
                    Software
                  </Typography.Text>
                </Link>{' '}
                für Ihren Postlogistik-Alltag mit der mail alliance zum Download oder verlinkt
              </Typography.Text>
            </Space>
          </List.Item>
          <List.Item>
            <Space align='baseline'>
              <Typography.Text style={{ color: 'red', fontWeight: 'bold' }}>✓</Typography.Text>
              <Typography.Text>
                wichtige{' '}
                <Link to='/documents'>
                  <Typography.Text strong style={{ color: 'red' }}>
                    Dokumente
                  </Typography.Text>
                </Link>{' '}
                als Hilfestellung und zur ergänzenden Information zum Download
              </Typography.Text>
            </Space>
          </List.Item>
          <List.Item>
            <Space align='baseline'>
              <Typography.Text style={{ color: 'red', fontWeight: 'bold' }}>✓</Typography.Text>
              <Typography.Text>
                mail Alliance{' '}
                <Link to={ROUTE_CONSTANTS.CONTACTS_PATH}>
                  <Typography.Text strong style={{ color: 'red' }}>
                    Kontakte
                  </Typography.Text>
                </Link>{' '}
                für Fragen und weiterführende Informationen
              </Typography.Text>
            </Space>
          </List.Item>
        </List>
      </Layout.Content>
    </Layout>
  );
}
